import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, NgModule } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'environments/environment';

@NgModule({
  imports: [MatIconModule],
})
export class IconsModule {
  /**
   * Constructor
   */
  constructor(
    private _domSanitizer: DomSanitizer,
    private _matIconRegistry: MatIconRegistry,
    @Inject(PLATFORM_ID) private _platformId: object,
  ) {
    // Icon sets are fetched over HTTP with relative URLs, which only
    // resolve in the browser — skip registration during SSR to avoid
    // failed request errors on every render.
    if (!isPlatformBrowser(this._platformId)) {
      return;
    }

    // Register icon sets
    this._matIconRegistry.addSvgIconSet(
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        environment.base + 'assets/icons/material-twotone.svg',
      ),
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'mat_outline',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        environment.base + 'assets/icons/material-outline.svg',
      ),
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'mat_solid',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        environment.base + 'assets/icons/material-solid.svg',
      ),
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'feather',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        environment.base + 'assets/icons/feather.svg',
      ),
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'heroicons_outline',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        environment.base + 'assets/icons/heroicons-outline.svg',
      ),
    );
    this._matIconRegistry.addSvgIconSetInNamespace(
      'heroicons_solid',
      this._domSanitizer.bypassSecurityTrustResourceUrl(
        environment.base + 'assets/icons/heroicons-solid.svg',
      ),
    );
  }
}
